<div class="date-range-filter-origin">
	<mat-icon class="date-range-filter-prefix">calendar_month</mat-icon>
	<button
		type="button"
		class="th-filter-input date-range-filter-trigger"
		[class.is-filtered]="hasValue()"
		[class.is-invalid]="invalid()"
		[disabled]="disabled()"
		[attr.aria-label]="labelKey() | transloco"
		[attr.aria-invalid]="invalid()"
		[attr.title]="displayValue()"
		(click)="picker.open()"
	>
		{{ hasValue() ? displayValue() : ('database_view.filters.date_range' | transloco) }}
	</button>
	@if (hasValue() && !disabled()) {
		<button matIconButton type="button" class="date-range-filter-clear" (click)="clear($event)">
			<mat-icon>close</mat-icon>
		</button>
	}
	<mat-date-range-input class="date-range-filter-anchor" [rangePicker]="picker">
		<input matStartDate [value]="start()" (dateInput)="onDateInput('start', $event.value)" />
		<input matEndDate [value]="end()" (dateInput)="onDateInput('end', $event.value)" />
	</mat-date-range-input>
	<mat-date-range-picker #picker></mat-date-range-picker>
</div>
